var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FDropdown',{attrs:{"items":_vm.displayYearOptions,"value":_vm.value,"disabled":_vm.disabled,"hideClear":_vm.hideClear},on:{"input":(v) => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }